import { render, staticRenderFns } from "./CourseRegistrationTab.vue?vue&type=template&id=1378793c"
import script from "./CourseRegistrationTab.vue?vue&type=script&lang=js"
export * from "./CourseRegistrationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports